import { render } from "./AddAliasDialog.vue?vue&type=template&id=35d0c2e4&ts=true"
import script from "./AddAliasDialog.vue?vue&type=script&lang=ts"
export * from "./AddAliasDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__